<div id="wrap">
    <div *ngIf="data" [@questionShowAnimation]>
        <div id="numberWrap">
            <div class="circle active fontSize16">
                1
            </div>

            <div class="line"></div>

            <div class="circle inactive fontSize16">
                2
            </div>
        </div>

        <div id="questionCard">
            <div id="question" class="fontSize14" [innerHtml]="currentQuestion.title">

            </div>

            <div class="optionItem option0"
                 (click)="optionClick(0)"
                 [ngClass]="{'optionActive0':optionArray[0].selected,'optionInactive0':!optionArray[0].selected}">
            </div>

            <div class="optionItem option1"
                 (click)="optionClick(1)"
                 [ngClass]="{'optionActive1':optionArray[1].selected,'optionInactive1':!optionArray[1].selected}">
            </div>

            <div class="optionItem option2"
                 (click)="optionClick(2)"
                 [ngClass]="{'optionActive2':optionArray[2].selected,'optionInactive2':!optionArray[2].selected}">
            </div>

            <div class="optionItem option3"
                 (click)="optionClick(3)"
                 [ngClass]="{'optionActive3':optionArray[3].selected,'optionInactive3':!optionArray[3].selected}">
            </div>

            <img [@answerShowAnimation] src="{{assetsRoute}}/picture/casepracticeauthorization/right.png" alt="" id="rightIcon" *ngIf="iconShowMode==1">
            <img [@answerShowAnimation] src="{{assetsRoute}}/picture/casepracticeauthorization/wrong.png" alt="" id="wrongIcon" *ngIf="iconShowMode==2">

            <div [@correctAnswerShowAnimation] id="questionAnswer" class="fontSize14" *ngIf="iconShowMode==2">
                正确答案：{{answerShow}}
            </div>
        </div>

        <div id="questionBtn" class="fontSize16" [ngClass]="{'questionBtnInactive':questionBtnMode==1,'questionBtnActive':questionBtnMode==2||questionBtnMode==3}"
             (click)="questionBtnClick()">
            <span *ngIf="questionBtnMode==1||questionBtnMode==2">看看我做对了没</span>
            <span *ngIf="questionBtnMode==3">下一步</span>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-cooperation-question/case-practice-cooperation-question.component.html